import { render, staticRenderFns } from "./FormChiTietAnPham.vue?vue&type=template&id=121b464b&scoped=true"
import script from "./FormChiTietAnPham.vue?vue&type=script&lang=js"
export * from "./FormChiTietAnPham.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b464b",
  null
  
)

export default component.exports